/**
 * ForecastStandardPrint — rapport « Prévisionnel simplifié » : UN seul rapport
 * multi-pages reprenant les onglets du hub Prévisionnel, chacun sur sa page :
 *   Synthèse · Compte de résultat prévisionnel · Cash flow.
 * On ne signale `onDataReady` au host qu'UNE fois les sous-rapports chargés.
 * (L'ancienne page BFRE a été retirée avec l'onglet — doublon du Bilan piloté.)
 */
import React, { useRef } from 'react';
import ForecastSummaryPrint from './ForecastSummaryPrint';
import ForecastPlPrint from './ForecastPlPrint';
import ForecastCashflowPrint from './ForecastCashflowPrint';

const SUB_COUNT = 3;

export default function ForecastStandardPrint({ activeTenant, year, editedAt, onDataReady }) {
  const done = useRef(0);
  const fired = useRef(false);
  const childReady = () => {
    done.current += 1;
    if (done.current >= SUB_COUNT && !fired.current) {
      fired.current = true;
      if (onDataReady) onDataReady('forecast-standard');
    }
  };
  const common = { activeTenant, year, editedAt, onDataReady: childReady };

  return (
    <>
      <ForecastSummaryPrint {...common} />
      <ForecastPlPrint {...common} />
      <ForecastCashflowPrint {...common} />
    </>
  );
}
